module.exports = __webpack_public_path__ + "img/9-1.ecd4f6d7.png";